import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Space, Typography } from 'antd';
import { Icon502 } from '../../assets/NomIcon';
import { resetReady } from '../views/Setup/setupSlice';

const { Title, Text } = Typography;

const ServerUnavailable = () => {
  const dispatch = useDispatch();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: '40px',
        color: 'var(--midnight-sky, #16151D)',
      }}
    >
      <Icon502 style={{ fontSize: '252px', marginBottom: '24px' }} />
      <Space direction="vertical" size={8} style={{ marginBottom: '32px' }}>
        <Title
          level={2}
          style={{
            margin: 0,
            color: 'var(--midnight-sky, #16151D)',
            fontFamily: '"Just Sans", sans-serif',
          }}
        >
          Something Went Wrong
        </Title>
        <Text
          style={{
            fontSize: '16px',
            color: 'var(--midnight-sky, #16151D)',
            opacity: 0.7,
          }}
        >
          We couldn't reach the NomiNode server. Check your network connection
          and try again.
        </Text>
      </Space>
      <Button
        type="primary"
        size="large"
        onClick={() => dispatch(resetReady())}
        style={{
          background: 'var(--electric-blue, #0055FF)',
          borderColor: 'var(--electric-blue, #0055FF)',
          fontFamily: '"Just Sans", sans-serif',
        }}
      >
        Retry
      </Button>
    </div>
  );
};

export default ServerUnavailable;
